var __jsx = React.createElement;
import React, { useState } from 'react';
import { getYear } from '../../../../utils/utilityFunction';
import { FooterCopyright } from '../../../../constants/labels/en';
import Para from '../../../atoms/Para';
var Copyright = function Copyright() {
  var _useState = useState(getYear()),
    year = _useState[0];
  return __jsx("div", {
    className: "nva-footer__copyright"
  }, __jsx(Para, {
    className: "nva-footer__copyright-text u-caption",
    removeDefaultStyles: true
  }, FooterCopyright.copyrightSymbol, " ", FooterCopyright.copyright, " ", year));
};
export default Copyright;